
import { Component, OnInit, HostListener, ElementRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { JsonService, LoadingService, GlobalService, LoggerService } from '../_services';
import { DialogService } from '../dialog/dialog.service';
import { StringSwitchService } from '../_helpers/string-switch.service';
import { TranslateService } from '@ngx-translate/core';
import { UnrecognizedItem, Group, PrescriptionResponse, Prescription, PrescriptionContent } from '../_models';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-detalhe',
  templateUrl: './detalhe.component.html',
  styleUrls: ['./detalhe.component.scss']
})
export class DetalheComponent implements OnInit {
  @ViewChildren(MatAutocompleteTrigger) autocompleteTriggers!: QueryList<MatAutocompleteTrigger>;
  @ViewChildren('especialidadeInput') especialidadeInputs!: QueryList<ElementRef>;
  @ViewChildren('produtoInput') produtoInputs!: QueryList<ElementRef>;
  @ViewChild('salvarButton') salvarButton!: ElementRef;
  @ViewChild('salvarButton1') salvarButton1!: ElementRef;

  public isVisibleDiagnostico: boolean = false;
  public isVisibleNomeMedico: boolean = false;
  public isVisibleEnderecoMedico: boolean = false;
  public isVisibleInstituicao: boolean = false;
  public isVisibleLocalidade: boolean = false;
  public isVisibleEnderecoinstituicao: boolean = false;
  public isVisibleEspecialidadeMedico: boolean = false;
  public isVisibleProduto: boolean = false;

  form!: FormGroup;
  thisItem!: Prescription;
  listImageQuality: any[] = [];
  listaRegiao: any[] = [];
  filtro: any = {};
  historico = '';
  crmFiltrado: string[] = [];
  nomeMedicoFiltrado: string[] = [];
  especialidadeFiltrado: string[] = [];
  produtoFiltrado: string[] = [];
  posologiaFiltrado: string[] = [];
  infoNotRecognizedOptions: UnrecognizedItem[] = [];
  infoNotRecognizedFiltred: UnrecognizedItem[] = [];
  filteredOptions!: Observable<string[]>;

  // flags
  isModalOpen = false;
  isModal1Open = false;
  temHistorico = false;
  temAnterior = false;
  canDestroy = false;
  doShortcutActive = true;
  isRefused = false;
  isSmartCase = true;
  isImageCollapsed = false;

  // dados receita
  uid = '';
  id_datacapture7 = '';
  status = '';
  pais = '';
  paisName = '';
  data_de_leitura = '';
  revisado: string | null = null;
  data_de_revisao = '';
  blobImage: any = 'loading.gif';
  pdv = '';
  regiao = '';
  groupId = '';
  groupName = '';
  filenameText = '';

  readonly opcoesInfoNotRecognized = [
    "Dados do médico", "Dados da instituição", "Dados do produto"
  ];

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private json: JsonService,
    private dialog: DialogService,
    private logger: LoggerService,
    private loading: LoadingService,
    public global: GlobalService,
    private stringSwitch: StringSwitchService
  ) {}

  // ------------ Lifecycle -----------------
  ngOnInit(): void {
    this.loading.show();
    this.filtro = this.getLocalStorageJSON('filtro') || {};
    this.uid = this.route.snapshot.paramMap.get('uid') || '';
    this.subscribeToDialogClose();
    this.loadNotRecognized();
    //this.global.loadInitialData();

    if (this.uid) {
      localStorage.setItem('prescriptionId', this.uid);
      this.getJsonData(this.uid);
      this.atualizarImageQuality();
      this.getRegionJson();
    }
  }

  // ------------ Helpers -----------------
  private getLocalStorageJSON<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }
  toggleCollapsedImage() { this.isImageCollapsed = !this.isImageCollapsed; }
  back() { this.location.back(); }
  backSpace() { this.router.navigate(['/receitas']); }
  switchString(v: string) { return this.stringSwitch.switchString(v); }

  // ✅ Autocomplete Recusa (filtra por code ou name)
  private normalize(v: any): string {
    return (v ?? '').toString().trim().toLowerCase();
  }

  private filterNotRecognized(term: any): UnrecognizedItem[] {
    const t = this.normalize(term);
    if (!t) return this.infoNotRecognizedOptions.slice();

    return this.infoNotRecognizedOptions.filter((x: any) => {
      const code = this.normalize(x.code);
      const name = this.normalize(x.name);
      return code.includes(t) || name.includes(t);
    });
  }

  private setupNotRecognizedAutocomplete(): void {
    const ctrl = this.form?.get('notReconize');
    if (!ctrl) return;

    // lista inicial
    this.infoNotRecognizedFiltred = this.filterNotRecognized(ctrl.value);

    // filtra ao digitar
    ctrl.valueChanges.subscribe(value => {
      this.infoNotRecognizedFiltred = this.filterNotRecognized(value);
    });
  }

  // ------------ Dialog / API -----------------
  private subscribeToDialogClose() {
    this.dialog.onClose$.subscribe(id => {
      ({ changeNext: () => this.nextPrescription(),
         aviso: () => this.loading.hide(),
         avisoEnd: () => this.router.navigate(['/receitas'])
      }[id]?.());
    });
  }
  private chamarApiAoSair(id: string | null = null) {
    if (!this.canDestroy) return;
    this.json.unlockAllPage().subscribe({ error: e => this.logger.error('unlockAllPage', e) });
    if (id) this.userLog(id, false);
  }

  // ------------ CRUD Receita -----------------
  private getJsonData(uid: string) {
    this.resetAllContent();
    this.confereBackID();
    this.json.lockPageRead(uid).subscribe({
      next: resp => {
        // username fica em sessionStorage desde o login novo (5b1602d); localStorage retornava null
        // e fazia toda receita parecer "acessada por outro usuário". Comparação case-insensitive:
        // o SQL não diferencia caixa no email, o !== do JS sim.
        if (resp.lockedBy && resp.lockedBy.toLowerCase() !== sessionStorage.getItem('username')?.toLowerCase()) {
          this.dialog.abrirDialog('aviso', 'Aviso!', 'Receita já acessada por outro usuário.');
          this.router.navigate(['/receitas']);
        } else if (resp.lockedBy) {
          // Lock já é do próprio usuário (F5/reentrada) — carrega direto
          this.getJsonDataGetItem(uid);
        } else {
          // Sem lock — cria primeiro e só carrega após confirmação (evita carga dupla e edição sem lock)
          this.createLock(uid);
        }
      },
      error: e => this.logger.error('lockPageRead', e)
    });
  }

  private createLock(uid: string) {
    const fd = new FormData();
    fd.append('status', '1'); fd.append('prescriptionId', uid);
    this.json.lockPageCreate(fd).subscribe({
      next: resp => {
        // Backend responde 200 com success=false quando a receita está em uso por outro
        // usuário ou não foi encontrada — respeitar em vez de abrir a tela mesmo assim
        if (resp && resp.success === false) {
          this.dialog.abrirDialog('aviso', 'Aviso!', resp.message || 'Receita já está em uso.');
          this.loading.hide();
          this.router.navigate(['/receitas']);
          return;
        }
        this.getJsonDataGetItem(uid);
      },
      error: e => this.logger.error('lockPageCreate', e)
    });
  }

  private getJsonDataGetItem(uid: string) {
    this.doShortcutActive = true;
    this.json.getItem(uid).subscribe({
      next: (resp: PrescriptionResponse) => {
        this.thisItem = resp.prescription;
        const conteudo: PrescriptionContent = JSON.parse(this.thisItem.conteudo);
        this.readCountryVisibleFieldsPrescription(this.thisItem['pais']);
        this.buildForm(conteudo);
        this.lockPageCreate(uid);
        this.userLog(uid, true);
        this.loadGroupName(this.thisItem.groupId);
        this.loadImage(uid);
      },
      error: e => this.logger.error('getItem', e)
    });
  }

  private lockPageCreate(uid: string) {
    const fd = new FormData();
    fd.append('status', '1'); fd.append('prescriptionId', uid);
    this.json.lockPageCreate(fd).subscribe({
      next: resp => {
        // Receita em uso por outro usuário (ex.: colisão na transição para a próxima) — avisa e volta
        if (resp && resp.success === false) {
          this.dialog.abrirDialog('aviso', 'Aviso!', resp.message || 'Receita já está em uso.');
          this.loading.hide();
          this.router.navigate(['/receitas']);
          return;
        }
        this.canDestroy = true; this.setItemData(); this.loading.hide();
      },
      error: e => this.logger.error('lockPageCreate', e)
    });
  }

  private setItemData() {
    const i = this.thisItem;
    this.filenameText = i.filename; this.uid = i.id; this.id_datacapture7 = i.aiDataCaptureid;
    this.status = i.status; this.groupId = i.groupId; this.pais = i.pais; this.readCountry(this.pais);
    this.data_de_leitura = i.dataLeitura; this.revisado = i.revisado; this.data_de_revisao = i.dataRevisao;
    this.historico = i.historicoConteudo; this.temHistorico = !!this.historico?.length;
    this.pdv = i.pdv; this.regiao = i.regiao;
    this.isSmartCase = !(i.status === 'W' || i.status === 'w');
  }

  private buildForm(c: PrescriptionContent) {
    let diagnosticos = c.diagnostico.length ? c.diagnostico : ['', ''];
    if (diagnosticos.length === 1) diagnosticos.push('');

    this.form = this.fb.group({
      dataReceita: [c.dataReceita],
      imageQuality: [this.thisItem.imageQuality ?? 'Legivel'],
      notReconize: [''],
      produto: this.fb.array((c.produto ?? []).map(p => this.createProduto(p))),
      medico: this.createMedico(c.medico),
      instituicao: this.createInstituicao(c.instituicao),
      diagnostico: this.fb.array(diagnosticos.map(d => new FormControl(d))),
      anonimizada: [this.thisItem.anonimizada ?? false]
    });

    // ✅ Corrigido: notReconize deve ser string, e o backend guarda array
    const saved = JSON.parse(this.thisItem.infoNotRecognized ?? '[]');
    this.form.patchValue({
      notReconize: Array.isArray(saved) ? (saved[0] ?? '') : (saved ?? '')
    });

    // ✅ Ativa o filtro reativo do autocomplete (form já existe)
    this.setupNotRecognizedAutocomplete();
  }

  private loadGroupName(id: string) {
    this.json.getGroupList().subscribe({
      next: (groups: Group[]) => this.groupName = groups.find(g => g.id === id)?.name || '',
      error: e => this.logger.error('getGroupList', e)
    });
  }

  private loadImage(uid: string) {
    this.json.getImageItem(uid).subscribe({
      next: b => this.blobImage = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(b)),
      error: e => this.logger.error('getImageItem', e)
    });
  }

  public irHistorico(): void {
    this.router.navigate(['/historico', this.uid]);
  }

  // ------------ Save -----------------
  ok() {
    this.isRefused = this.form.get('imageQuality')?.value === 'Recusada';
    if (this.form.invalid && this.isRefused === false) {
      this.dialog.abrirDialog('aviso', 'Aviso!', 'Preencha todos os campos requeridos.');
      this.form.markAllAsTouched();
      return;
    }

    this.doShortcutActive = false; this.isModalOpen = true;
    setTimeout(() => this.salvarButton?.nativeElement.focus(), 0);
  }

  saveChanges() {
    this.loading.show();
    const v = { ...this.form.value };
    v.infoNotRecognized = (v.infoNotRecognized || [])
      .map((c: boolean, i: number) => c ? this.opcoesInfoNotRecognized[i] : null).filter(Boolean);

    this.closeModal(); this.closeModal1();

    const fd = new FormData();
    fd.append('id', this.uid);
    fd.append('conteudo', JSON.stringify({ ...v, infoNotRecognized: undefined }));
    fd.append('imageQuality', this.form.get('imageQuality')?.value);
    fd.append('infoNotRecognized', JSON.stringify([this.form.get('notReconize')?.value])); // string (name)
    fd.append('anonimizada', this.form.get('anonimizada')?.value);

    this.json.sendItem(fd).subscribe({
      next: () => { this.isModal1Open = true; setTimeout(() => this.salvarButton1?.nativeElement.focus(), 200); },
      error: e => this.logger.error('sendItem', e)
    });
  }

  // ------------ Navegação -----------------
  nextPrescription(isSave = false) {
    this.loading.show(); this.isModal1Open = false; this.userLog(this.uid, false);
    let params = new HttpParams(), onReview = false;
    Object.entries(this.filtro).forEach(([k, v]) => {
      if (k === 'regiao') params = params.append('region', v as string);
      else if (isSave && k === 'status') { params = params.append('status', 'W'); onReview = true; }
      else params = params.append(k, v as string);
    });
    params = params.append('onReview', onReview).append('id', this.uid);
    this.json.getNextPage(params).subscribe({
      next: r => {
        if (r.isNull) return this.dialog.abrirDialog('avisoEnd', 'Aviso!', 'Não há receita anterior.');
        this.uid = r.prescription['id']; this.resetAllContent(); this.chamarApiAoSair();
        this.confereBackID(); this.router.navigate(['/receita', this.uid]);
        localStorage.setItem('prescriptionId', this.uid); this.getJsonDataGetItem(this.uid);
      },
      error: e => { this.logger.error('getNextPage', e); this.dialog.abrirDialog('aviso', 'Info!', 'Sessão expirada.'); this.loading.hide(); }
    });
  }

  prescriptionBack() {
    let ids = JSON.parse(localStorage.getItem('listIDs') || '[]');
    const backId = Array.isArray(ids) ? ids.slice().reverse().find((id: string) => id !== this.uid) : this.uid;
    this.userLog(this.uid, false); this.uid = backId;
    this.lockpageAndGetdata(backId); this.resetAllContent(); localStorage.setItem('prescriptionId', this.uid);
  }

  private lockpageAndGetdata(uid: string) {
    const fd = new FormData(); fd.append('status', '1'); fd.append('prescriptionId', uid);
    this.json.lockPageCreate(fd).subscribe({
      next: () => { this.router.navigate(['/receita', uid]); this.getJsonData(uid); },
      error: e => this.logger.error('lockPageCreate', e)
    });
    this.userLog(uid, true);
  }

  // ------------ Auxiliares -----------------
  resetAllContent() {
    this.temHistorico = false;
    this.blobImage = 'loading.gif';
    this.form?.reset();
  }
  readCountry(id: string) {
    this.json.readCountry(id).subscribe({
      next: r => this.paisName = r.name,
      error: e => this.logger.error('readCountry', e)
    });
  }
  getRegionName(id: string) {
    return this.listaRegiao.find(r => r.id === id)?.name || 'Región no encontrada';
  }
  confereBackID() {
    const ids = JSON.parse(localStorage.getItem('listIDs') || '[]');
    if (Array.isArray(ids)) {
      if (ids.at(-1) !== this.uid) ids.push(this.uid);
      localStorage.setItem('listIDs', JSON.stringify(ids));
      this.temAnterior = ids.length >= 2;
    }
  }
  async userLog(id: string, entry: boolean) {
    const fd = new FormData(); fd.append('isEntry', String(entry)); fd.append('prescriptionId', id);
    this.json.userLog(fd).subscribe({ error: e => this.logger.error('userLog', e) });
  }

  async getRegionJson() {
    this.json.getRegiao().subscribe(
      resp => { this.listaRegiao = resp; },
      erro => { this.logger.error('Erro ao carregar regiões', erro); }
    );
  }

  loadNotRecognized() {
    this.json.getUnrecognizedItems().subscribe({
      next: r => {
        this.infoNotRecognizedOptions = r;
        this.infoNotRecognizedFiltred = r;

        // ✅ Se o form já existe, re-aplica o filtro com base no valor atual
        if (this.form) this.setupNotRecognizedAutocomplete();
      },
      error: e => this.logger.error('getUnrecognizedItems', e)
    });
  }

  async atualizarImageQuality() {
    this.listImageQuality = await this.json.getImageQuality().toPromise();
  }

  // ------------ Form Builders -----------------
  get diagnosticos() {
    return this.form.get('diagnostico') as FormArray;
  }
  get produtos() {
    return this.form.get('produto') as FormArray;
  }
  createProduto(d = { nome: '', posologia: '' }) {
    return this.fb.group({ nome: [d.nome, Validators.required], posologia: [d.posologia] });
  }
  createMedico(d: any = {}) {
    d = d || {};
    const tels = [...(d.telefone || []), '', ''].slice(0, 2);
    const esp = d.especialidade?.length ? d.especialidade : [''];
    return this.fb.group({
      nome: [d.nome], matricula: [d.matricula], email: [d.email], rua: [d.rua], localidade: [d.localidade],
      telefone: this.fb.array(tels.map(t => new FormControl(t))),
      especialidade: this.fb.array(esp.map(e => new FormControl(e)))
    });
  }
  createInstituicao(d: any = {}) {
    d = d || {};
    const tels = [...(d.telefone || []), '', ''].slice(0, 2);
    return this.fb.group({
      nomeInstituicao: [d.nomeInstituicao], email: [d.email], rua: [d.rua], localidade: [d.localidade],
      telefone: this.fb.array(tels.map(t => new FormControl(t)))
    });
  }
  validarEntrada(event: KeyboardEvent) {
    const caracteresProibidos = ['|', ',', ';'];
    if (caracteresProibidos.includes(event.key)) {
      event.preventDefault();
    }
  }

  // ------------ Atalhos teclado -----------------
  // @HostListener('window:keydown', ['$event'])
  // handleKeyboardEvent(e: KeyboardEvent) {
  //   if (!e.altKey || !this.doShortcutActive) return; e.preventDefault();
  //   ({ Enter: () => this.ok(), P: () => this.nextPrescription(),
  //      p: () => this.nextPrescription(), A: () => this.prescriptionBack(),
  //      a: () => this.prescriptionBack(), C: () => this.toggleCollapsedImage(),
  //      c: () => this.toggleCollapsedImage(), Backspace: () => this.backSpace()
  //   }[e.key]?.());
  // }

@HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(e: KeyboardEvent) {
  // ---- SHIFT + SETA PARA BAIXO / CIMA → navegar produtos ----
  if (e.shiftKey && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
    e.preventDefault();
    this.focusNextField(e.key === 'ArrowDown' ? +1 : -1);
    return;
  }

    // ---- Atalhos ALT existentes ----
    if (!e.altKey || !this.doShortcutActive) return;

    e.preventDefault();

    ({
      Enter: () => this.ok(),
      P: () => this.nextPrescription(),
      p: () => this.nextPrescription(),
      A: () => this.prescriptionBack(),
      a: () => this.prescriptionBack(),
      C: () => this.toggleCollapsedImage(),
      c: () => this.toggleCollapsedImage(),
      Backspace: () => this.backSpace(),
    }[e.key]?.());
  }

 private focusNextField(direction: 1 | -1 = 1): void {
  const activeElement = document.activeElement as HTMLElement | null;
  if (!activeElement) return;

  // --- REGRA ESPECÍFICA: SHIFT+↓/↑ em nome/posologia -> "nome" do próximo/anterior produto ---
  const fc = activeElement.getAttribute?.('formcontrolname');
  if (fc === 'nome' || fc === 'posologia') {
    const container = activeElement.closest('.product_data__items_scroll') as HTMLElement | null;

    if (container) {
      // Linhas do produto: .flex que contém input nome
      const rows = Array.from(container.querySelectorAll<HTMLElement>('.flex'))
        .filter(r => !!r.querySelector('input[formcontrolname="nome"]'));

      const currentRowIndex = rows.findIndex(r => r.contains(activeElement));

      if (currentRowIndex >= 0) {
        const start = currentRowIndex + direction;

        if (direction === 1) {
          for (let i = start; i < rows.length; i++) {
            const nextNome = rows[i].querySelector<HTMLElement>('input[formcontrolname="nome"]');
            if (nextNome && !nextNome.hasAttribute('disabled') && nextNome.offsetParent !== null) {
              nextNome.focus();
              return;
            }
          }
        } else {
          for (let i = start; i >= 0; i--) {
            const prevNome = rows[i].querySelector<HTMLElement>('input[formcontrolname="nome"]');
            if (prevNome && !prevNome.hasAttribute('disabled') && prevNome.offsetParent !== null) {
              prevNome.focus();
              return;
            }
          }
        }
      }
    }

    // Se não achou anterior/próximo, pode só cair no fluxo normal abaixo
    // (ou dar return se você quiser bloquear o fallback)
  }

  // --- DAQUI PRA BAIXO: mantém seu comportamento original (diagnóstico / imageQuality / etc) ---
  // ... seu código existente ...
}

  @HostListener('window:beforeunload', ['$event'])
  aoFecharOuRecarregar() {
    this.chamarApiAoSair();
  }

  // ------------ Modais -----------------
  openModal() {
    this.isModalOpen = true;
  }
  closeModal(shortcut = false) {
    this.isModalOpen = false;
    if (shortcut) this.doShortcutActive = true;
  }
  closeModal1() {
    this.isModal1Open = false;
  }

  public readCountryVisibleFieldsPrescription(id: string) {
    this.json.readCountry(id).subscribe(
      resp => {
        if (resp.visiblePrescriptionFields != null) {
          this.isVisibleDiagnostico =  resp.visiblePrescriptionFields.includes("diagnostico");
          this.isVisibleInstituicao =  resp.visiblePrescriptionFields.includes("nomeInstituicao");
          this.isVisibleEnderecoinstituicao =  resp.visiblePrescriptionFields.includes("enderecoInstituicao");
          this.isVisibleNomeMedico =  resp.visiblePrescriptionFields.includes("nomeMedico");
          this.isVisibleEnderecoMedico =  resp.visiblePrescriptionFields.includes("enderecoMedico");
          this.isVisibleEspecialidadeMedico =  resp.visiblePrescriptionFields.includes("especialidade");
          this.isVisibleProduto =  resp.visiblePrescriptionFields.includes("produto");
        } else {
          console.log("O campo 'diagnostico' não está presente.");
        }
      },
      erro => {
        this.logger.error('Erro ao ler campo visibleFiledsPrescricao', erro);
        // Definir visibilidade padrão em caso de erro
        this.isVisibleDiagnostico = true;
        this.isVisibleInstituicao = true;
        this.isVisibleEnderecoinstituicao = true;
        this.isVisibleNomeMedico = true;
        this.isVisibleEnderecoMedico = true;
        this.isVisibleEspecialidadeMedico = true;
        this.isVisibleProduto = true;
      }
    );
  }

confirmRecusaEnter(event: KeyboardEvent, trigger: MatAutocompleteTrigger): void {
  event.preventDefault();
  event.stopPropagation();

  const ctrl = this.form?.get('notReconize');
  if (!ctrl) return;

  // 1) Se o painel está aberto e tem opção ativa, seleciona ela
  if (trigger?.panelOpen) {
    const active = (trigger as any).activeOption; // activeOption não é tipado em algumas versões
    if (active) {
      active.select();          // dispara optionSelected e escreve no input
      trigger.closePanel();
      return;
    }
  }

  const raw = (ctrl.value ?? '').toString();
  const term = this.normalize(raw);

  // 2) Match exato por code OU name (digitou e apertou enter)
  const found = this.infoNotRecognizedOptions.find((x: any) => {
    const code = this.normalize(x.code);
    const name = this.normalize(x.name);
    return code === term || name === term;
  });

  if (found) {
    ctrl.setValue(found.name, { emitEvent: true }); // mantém seu padrão: salva o name (string)
    trigger?.closePanel();
    return;
  }

  // 3) Se sobrou 1 opção no filtro, assume ela
  if (this.infoNotRecognizedFiltred?.length === 1) {
    ctrl.setValue(this.infoNotRecognizedFiltred[0].name, { emitEvent: true });
    trigger?.closePanel();
    return;
  }

  // Se não encontrou nada, só fecha o painel (mantém o texto digitado)
  trigger?.closePanel();
}


}
